import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BasicModal } from '../common/modals/BasicModal';

class StatementPreferenceConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this._noButtonClick = this._noButtonClick.bind(this);
    this._yesButtonClick = this._yesButtonClick.bind(this);
  }

  _noButtonClick() {
    this.props._confirmationModal(false);
  }

  _yesButtonClick() {
    this.props._onBackClickConfirmation();
  }

  render() {
    return (
      <BasicModal>
        <div className="modalb msg-popup single-msg">
          <div className="modalb-container">
            <h5>Your changes haven't been saved</h5>
            <p>Are you sure you want to leave?</p>
          </div>
          <div className="modalb-footer">
            <button
              className="c-btn c-btn--secondary"
              ref="noButton"
              onClick={this._noButtonClick}
            >
              No
            </button>
            <button
              className="c-btn c-btn--default"
              ref="yesButton"
              onClick={this._yesButtonClick}
            >
              Yes
            </button>
          </div>
        </div>
      </BasicModal>
    );
  }
}

StatementPreferenceConfirmationModal.propTypes = {
  content: PropTypes.object,
  _confirmationModal: PropTypes.func,
  _onBackClickConfirmation: PropTypes.func,
};

export default StatementPreferenceConfirmationModal;
